import { render, staticRenderFns } from "./CompanyDebtCollectionModal.vue?vue&type=template&id=0f70bd79&scoped=true&"
import script from "./CompanyDebtCollectionModal.vue?vue&type=script&lang=js&"
export * from "./CompanyDebtCollectionModal.vue?vue&type=script&lang=js&"
import style0 from "./CompanyDebtCollectionModal.vue?vue&type=style&index=0&id=0f70bd79&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f70bd79",
  null
  
)

component.options.__file = "CompanyDebtCollectionModal.vue"
export default component.exports